module.exports = __webpack_public_path__ + "static/media/fight.45322fa6.png";